// Redux
import { Reducer } from 'redux';
import { cloneDeep } from 'lodash';
import { produce, Draft } from 'immer';

// Models
import {
  EntitiesActionTypes,
  EntitiesState,
  EntityAlerts,
} from 'app/modules/entitiesOld/models';

// Actions
import { EntitiesActions } from 'app/modules/entitiesOld/actions';
import { AlertsActions } from 'app/modules/alerts/actions';

// Utils
import deepFreeze from 'app/shared/utils/deepFreeze';

// Constants
import { EMPTY_ENTITY } from 'app/modules/entitiesOld/constants';

export const initialPaginatedEntityAlerts: EntityAlerts = {
  count: 0,
  alerts: [],
};

const initialState: Readonly<EntitiesState> = {
  details: EMPTY_ENTITY,
};
// to ensure initialState is readonly
deepFreeze(initialState);

const reducer: Reducer<EntitiesState> = (
  state = initialState,
  action: EntitiesActions | AlertsActions,
) => {
  return produce(state, (draft: Draft<EntitiesState>) => {
    switch (action.type) {
      case EntitiesActionTypes.RETRIEVE_ENTITY_SUCCESS:
        draft.details = action.payload;
        return;

      case EntitiesActionTypes.RETRIEVE_ENTITY_ALERTS_SUCCESS:
        draft.details.paginated_alerts = action.payload;
        return;

      case EntitiesActionTypes.CLEAR_ALL_ENTITY_STATE:
        // eslint-disable-next-line consistent-return
        return cloneDeep(initialState);
    }
  });
};

export { reducer as entitiesReducer, initialState };
